<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceIndex) in slices"
      :key="sliceIndex"
      :slice="slice"
    />
  </div>
</template>

<script>
import { Hero, CustomerService } from '@@/shared-slices'

import {
  TestimonialsScore,
  TestimonialList,
  Medias,
  Faq,
  SimpleSlice,
  BottomBanner,
} from './components'

export default {
  name: 'TestimonialsModule',

  components: {
    hero: Hero,
    testimonials_score: TestimonialsScore,
    testimonial_list: TestimonialList,
    medias: Medias,
    faq: Faq,
    customer_service: CustomerService,
    simple_slice: SimpleSlice,
    bottom_banner: BottomBanner,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      slices: this.data.body,
    }
  },
}
</script>
